import { render, staticRenderFns } from "./PercentRing.vue?vue&type=template&id=5cab8aa0&scoped=true&"
import script from "./PercentRing.vue?vue&type=script&lang=js&"
export * from "./PercentRing.vue?vue&type=script&lang=js&"
import style0 from "./PercentRing.vue?vue&type=style&index=0&id=5cab8aa0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cab8aa0",
  null
  
)

export default component.exports